import React, { useEffect } from 'react'
import { Link } from "react-router-dom";

const FacilitiesLeftTab = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);
    return (
        <div className="additional-information">
            <div className="list">
                <ul>
                    <Link to="/infrastructure/central-facilities" ><li className='text-black'><i className="fa fa-university"></i> Central Facilities</li></Link>
                    <Link to="/infrastructure/physically-handicapped" ><li className='text-black'><i className="fa fa-wheelchair"></i> Physically Handicapped - Facilities </li></Link>
                    <Link to="/infrastructure/transport" ><li className='text-black'><i className="fa fa-bus"></i> Transport Facility</li></Link>
                    <Link to="/infrastructure/parking">
                        <li className='text-black'><i className="fas fa-parking"></i> Parking Facility</li>
                    </Link>
                    <Link to="/infrastructure/computer-centre" ><li className='text-black'><i className="fa fa-laptop"></i> Computer Centre </li></Link>
                    <Link to="/infrastructure/swec-campus-hostel" ><li className='text-black'><i className="fa fa-bed"></i> SWEC Campus Hostel</li></Link>
                    <Link to="/infrastructure/ict" ><li className='text-black'><i className="fa fa-plug"></i> ICT</li></Link>
                    <Link to="/infrastructure/green-initiatives" ><li className='text-black'><i className="fa fa-leaf"></i> Green Initiatives</li></Link>
                    <Link to="/infrastructure/sustainable-development-goals">
                        <li className="text-black">
                            <i className="fa fa-globe"></i> Sustainable Development Goals
                        </li>
                    </Link>
                    <Link to="/infrastructure/certification" >
                        <li className="text-black">
                            <i className="fa-solid fa-file-alt"></i> Infrastructure Certificates
                        </li>
                    </Link>
                    {/* <Link to="/infrastructure/sports" >
                        <li className="text-black">
                            <i className="fas fa-basketball-ball"></i> Infrastructure Sports
                        </li>
                    </Link> */}
                    <Link to="/infrastructure/photos">
                        <li className="text-black">
                            <i className="fas fa-images"></i> Infrastructure & Facilities Photos
                        </li>
                    </Link>



                </ul>
            </div>
        </div>
    )
}

export default FacilitiesLeftTab
